<template>
  <div class="tag-selector">
    <el-tag size="middle" style="margin-right: 10px;" closable v-for="(item,index) in value" :key="index"
    @close="closeTag(item)"
    >{{item}}</el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="$event.target.blur"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
    <el-card style="max-height: 200px;overflow-y: scroll;" v-if="tagList.length > 0">
      <el-button class="card-button" size="small" v-for="item in tagList" @click="clickTag(item.name)" :key="item.id"
      :type="item.name | valueClassFilter(value)"
      :disabled="item.name | valueFilter(value)"
      >{{item.name}}</el-button>
    </el-card>
  </div> 
</template>
<script>
export default {
  filters: {
    valueFilter(tag,value){
      return value.indexOf(tag) >= 0 ? true : false
    },
    valueClassFilter(tag,value){
      return value.indexOf(tag) >= 0 ? 'info' : 'success'
    }
  },
  props: {
    tagList: {
      required: true,
      type: Array,
    },
    value: {
      required: true,
      type: Array,
    },
    quantity: {
      require: false,
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    clickTag(tag){
      if(this.value.length >= this.quantity) {
        this.$message.error(`帖子关联标签最多${this.quantity}个`);
        return false
      }
      let arr = [...this.value]
      arr.push(tag)
      this.$emit('input', arr)
    },
    closeTag(tag) {
      let arr = [...this.value]
      arr.splice(this.value.indexOf(tag), 1);
      this.$emit('input', arr)
      // 如果关闭的标签是客服标签，则提示是否关闭
      // const tagBool = this.tagList.map(item => item.name).indexOf(tag)
      // if(tagBool === -1) {
      //   this.$confirm('此操作将删除视频自带标签?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //   arr.splice(this.value.indexOf(tag), 1);
      //   this.$emit('input', arr)
      //   }).catch(() => {
      //     return false
      //   });
      // } else {
      // }
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if(this.value.length >= this.quantity) {
        this.$message.error(`帖子关联标签最多${this.quantity}个`);
        this.inputVisible = false;
        this.inputValue = '';
        return false
      }
      if (inputValue) {
        let arr = [...this.value]
        arr.push(inputValue);
        this.$emit('input', arr)
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
  }
}
</script>
<style scoped lang="scss">
  .el-tag + .el-tag {
    /* margin-left: 10px; */
  }
  .button-new-tag {
    /* margin-left: 10px; */
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    /* margin-left: 10px; */
    vertical-align: bottom;
  }

  .tag-selector {
    .card-button {
      margin-left: 0;
      margin-right: 10px;
    }

    /deep/ .el-card__body {
      padding-top: 10px;
      padding-right: 10px;
    }
  }
</style>